// Phase 18 · Community · Marketplace asset embed card
import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, ArrowRight } from "lucide-react";

export default function MarketplaceEmbedCard({ preview }) {
    if (!preview) return null;
    return (
        <div
            className="rounded-lg border border-[#CCCCCC]/20 bg-gradient-to-br from-[#FFFFFF]/5 to-[#CCCCCC]/5 p-3 flex gap-3"
            data-testid={`marketplace-embed-${preview.id}`}
        >
            {preview.thumbnail_url ? (
                <img
                    src={preview.thumbnail_url}
                    alt={preview.title}
                    className="w-16 h-16 rounded-lg object-cover border border-[#1A1A1A] flex-shrink-0"
                />
            ) : (
                <div className="w-16 h-16 rounded-lg bg-[#111111] border border-[#1A1A1A] flex items-center justify-center flex-shrink-0">
                    <ShoppingBag size={22} className="text-[#CCCCCC]" />
                </div>
            )}
            <div className="flex-1 min-w-0">
                <p className="text-[10px] uppercase tracking-widest text-[#CCCCCC] font-semibold mb-0.5">
                    Marketplace · {preview.source === "phase16c" ? "Creator" : "Original"}
                </p>
                <p className="text-sm font-semibold text-neutral-100 truncate">
                    {preview.title}
                </p>
                <div className="flex items-center gap-3 mt-1.5">
                    {preview.price_credits ? (
                        <span className="text-xs text-neutral-300 font-mono">
                            {preview.price_credits} credits
                        </span>
                    ) : preview.price_eur ? (
                        <span className="text-xs text-neutral-300 font-mono">
                            $ {preview.price_eur}
                        </span>
                    ) : null}
                    {preview.url && (
                        <Link
                            to={preview.url}
                            className="inline-flex items-center gap-1 text-xs text-[#FFFFFF] hover:text-[#CCCCCC] font-medium transition-colors"
                            data-testid={`marketplace-embed-view-${preview.id}`}
                        >
                            View <ArrowRight size={12} />
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
